import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { resetForNewTestCase } from '../automationStudioNewSlice';
import {
    consumeAutomationStudioSessionPreserve,
    readAutomationStudioLastRoute,
    shouldResetAutomationStudioOnRouteChange,
    writeAutomationStudioLastRoute,
} from '../automationStudioSession';

/**
 * Clears in-memory Automation Studio state when the user leaves and re-enters,
 * or when the studio URL changes after navigation away (legacy route-session pattern).
 */
export default function useAutomationStudioRouteSession({ clearAutomationData } = {}) {
    const dispatch = useDispatch();
    const location = useLocation();

    useEffect(() => {
        const currentPath = location.pathname || '';
        const preserveSession = consumeAutomationStudioSessionPreserve();

        if (preserveSession) {
            writeAutomationStudioLastRoute(currentPath);
            return;
        }

        const lastRoute = readAutomationStudioLastRoute();
        if (shouldResetAutomationStudioOnRouteChange(lastRoute, currentPath)) {
            try {
                clearAutomationData?.();
            } catch (error) {
                console.error('[AutomationStudioNew] Failed to clear WS data on re-entry', {
                    error,
                    lastRoute,
                    currentPath,
                });
            }
            dispatch(resetForNewTestCase());
        }

        writeAutomationStudioLastRoute(currentPath);
    }, [location.pathname, dispatch, clearAutomationData]);

    useEffect(() => {
        return () => {
            if (typeof window !== 'undefined') {
                writeAutomationStudioLastRoute(window.location.pathname || '');
            }
        };
    }, []);
}
